import { useTheme } from "../styles/theme";

export default function SectionTitle({ children, style }) {
  const S = useTheme();
  return <h2 style={{ ...S.sectionTitle, ...style }}>{children}</h2>;
}
